import React, { FC } from 'react';

import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { IServerOrder } from '@rbi-ctg/menu';
import FullPageScreen from 'components/full-page-screen';
import LoadingAnimation from 'components/loading-animation';
import { useLogger } from 'state/logger';
import { OrderStatus } from 'state/order';
import { routes } from 'utils/routing';

import { StoreOrderConfirmationPageContent } from './store-order-confirmation-page-content';
import { useStoreOrder } from './use-store-order';

const StyledFullPageScreen = styled(FullPageScreen)`
  section {
    justify-content: center;
    width: 100vw;
    flex-direction: row;
  }
`;

export const StoreOrderConfirmationPage: FC = ({ children }) => {
  const { formatMessage } = useIntl();

  return (
    <div data-testid="store-order-confirmation">
      <StyledFullPageScreen
        heading={formatMessage({ id: 'orderConfirmation' })}
        closeHref={routes.base}
      >
        {children}
      </StyledFullPageScreen>
    </div>
  );
};

export interface IConfirmationUIProps {
  serverOrder: IServerOrder;
}

export const StoreOrderConfirmation: FC = () => {
  const logger = useLogger();
  const navigate = useNavigate();
  const storeOrderJwt = new URL(window.location.href).searchParams.get('catering') || '';

  if (!storeOrderJwt) {
    navigate(routes.base, { replace: true });
  }

  const { loading, serverOrder, updateOrderStatus, mutationResult } = useStoreOrder({
    storeOrderJwt,
    logger,
  });
  const mutationResultStatus =
    mutationResult &&
    mutationResult.confirmCateringOrder &&
    mutationResult.confirmCateringOrder.status;
  const cateringStatus = mutationResultStatus || (serverOrder && serverOrder.status);
  const { formatMessage } = useIntl();
  return (
    <>
      <Helmet title={formatMessage({ id: 'orderConfirmation' })} />
      <StoreOrderConfirmationPage>
        {loading ? (
          <LoadingAnimation fillColor={Styles.color.primaryHover} />
        ) : (
          <StoreOrderConfirmationPageContent
            serverOrder={serverOrder}
            cateringStatus={cateringStatus as OrderStatus}
            onStoreOrderStatusUpdate={updateOrderStatus}
          />
        )}
      </StoreOrderConfirmationPage>
    </>
  );
};

export default StoreOrderConfirmation;
